import { gql } from "@apollo/client";

export const CREATE_ISSUE = gql`
mutation CreateIssue($TaskTitle: String,$issuedescription: String,$Instructions:String,$Status: String,$Assignedto:[String], $CreatedBy:String,$GuidedBy:String,$Tabname: String, $DateAndTime: String,$Priority:String, $Deadline:String, $fileNames: [String],$urls:[String],){
  CreateIssue(TaskTitle: $TaskTitle,issuedescription: $issuedescription,Instructions:$Instructions, CreatedBy:$CreatedBy,Status:$Status,Assignedto:$Assignedto,GuidedBy:$GuidedBy,Tabname: $Tabname, DateAndTime: $DateAndTime,Priority:$Priority,Deadline:$Deadline, fileNames: $fileNames,urls:$urls){
    TaskID
    TaskTitle
    issuedescription
    CreatedBy
    GuidedBy
    Priority
    Assignedto
    Instructions
    Deadline
    Tabname
    DateAndTime
    Status
    Assignedto
    Remarks
    fileNames
    urls
  }
}
`;
export const GET_ALL_ISSUES = gql`
query{
  GetAllIssues{
  _id
  TaskID
  TaskTitle
    Tabname
   issuedescription
   CreatedBy
   GuidedBy
   CodeSnippet
   HoursSpent
   QualityScore
   UpdatedDate
    Priority
    Deadline
    TechStack
    DateAndTime
    Status
    Assignedto
    Remarks 
    fileNames
    urls
    Instructions
    FinalRemarks
  }
}
`;
export const UPDATE_ISSUE = gql`
  mutation UpdateIssue($_id: String,$issuedescription: String,$TaskTitle:String, $CreatedBy:String,$GuidedBy:String,$Tabname: String, $TechStack:[String],$CodeSnippet:String,$Priority:String, $Deadline:String,$HoursSpent:String,$QualityScore:Float,$Status: String, $Assignedto: [String],$Remarks: String,$Instructions: String,$FinalRemarks: String) {
    UpdateIssue(_id: $_id,issuedescription: $issuedescription, Tabname: $Tabname,CreatedBy:$CreatedBy,GuidedBy:$GuidedBy,TaskTitle:$TaskTitle, Status: $Status,TechStack:$TechStack,Priority:$Priority,Deadline:$Deadline,CodeSnippet:$CodeSnippet,HoursSpent:$HoursSpent,QualityScore:$QualityScore,Assignedto: $Assignedto,Remarks:$Remarks,Instructions:$Instructions,FinalRemarks:$FinalRemarks) {
      _id
      issuedescription
      Tabname
      TaskTitle
      CreatedBy
      GuidedBy
      Priority
      Deadline
      TechStack
      CodeSnippet
      QualityScore
      HoursSpent
      Status
      Assignedto
      Remarks
      Instructions
      FinalRemarks
    }
  }
`;
export const DELETE_ISSUE = gql`
mutation DeleteIssue($id: String!) {
  DeleteIssue(id: $id) {
    _id
  }
}`;
